import { render } from "./BaseSpinner.vue?vue&type=template&id=1a64dced"
import script from "./BaseSpinner.vue?vue&type=script&lang=js"
export * from "./BaseSpinner.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseSpinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a64dced"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a64dced', __exports__)) {
    console.log('reload')
    api.reload('1a64dced', __exports__)
  }
  
  module.hot.accept("./BaseSpinner.vue?vue&type=template&id=1a64dced", () => {
    console.log('re-render')
    api.rerender('1a64dced', render)
  })

}


export default __exports__